import { useRef, useState } from "react";
import axios from "axios";
import { youtube_parser } from "./utils";
import logo from "./youtube.png";
import "./App.css";

function App() {
  const inputUrlRef = useRef();
  const [urlResult, setUrlResult] = useState(null);
  const [title, setTitle] = useState(null);
  const [fileSize, setFileSize] = useState(null);
  const [duration, setDuration] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const formatDuration = (seconds) => {
    if (!seconds) return "0:00";
    const minutes = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${minutes}:${secs < 10 ? "0" : ""}${secs}`;
  };

  const formatFileSize = (bytes) => {
    if (!bytes) return "0 MB";
    const mb = bytes / (1024 * 1024);
    return `${mb.toFixed(2)} MB`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const youtubeUrl = inputUrlRef.current.value.trim();

    if (
      !youtubeUrl ||
      (!youtubeUrl.includes("youtube.com") && !youtubeUrl.includes("youtu.be"))
    ) {
      setError("Please enter a valid YouTube URL");
      return;
    }

    setError(null);
    setIsLoading(true);

    try {
      const youtubeID = youtube_parser(youtubeUrl);
      if (!youtubeID) {
        throw new Error("Invalid YouTube URL");
      }

      const options = {
        method: "GET",
        url: "https://youtube-mp36.p.rapidapi.com/dl",
        headers: {
          "X-RapidAPI-Key":
            "c93799809cmsh31c8bb66433bca9p1693f9jsne8e160be8cd3",
          "X-RapidAPI-Host": "youtube-mp36.p.rapidapi.com",
        },
        params: { id: youtubeID },
      };

      const res = await axios(options);
      setUrlResult(res.data.link);
      setTitle(res.data.title);
      setFileSize(res.data.filesize);
      setDuration(res.data.duration);
      inputUrlRef.current.value = "";
    } catch (err) {
      setError("Failed to convert video. Please try again.");
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="app">
      <nav className="navbar">
        <a className="navbar-brand" href="/" aria-label="Home">
          MP3 Converter
        </a>
      </nav>
      <div className="main-container">
        <img className="youtube-logo" src={logo} alt="YouTube Logo" />
        <h1 className="title">YouTube to MP3 Converter</h1>
        <p className="description">
          Transform your favorite YouTube videos into MP3 files instantly!
        </p>
        <form onSubmit={handleSubmit} aria-label="YouTube URL submission form">
          <input
            ref={inputUrlRef}
            type="text"
            className="url-input"
            placeholder="Enter YouTube URL..."
            aria-label="YouTube video URL"
            disabled={isLoading}
          />
          <button
            type="submit"
            className="search-button"
            disabled={isLoading}
            aria-label={isLoading ? "Converting..." : "Convert to MP3"}
          >
            {isLoading ? "Converting..." : "Convert"}
          </button>
        </form>
        {isLoading && (
          <div className="loader" aria-live="polite" aria-busy="true">
            <div className="spinner"></div>
            <p>Converting...</p>
          </div>
        )}
        {error && (
          <p className="error-message" role="alert">
            {error}
          </p>
        )}
        {urlResult && !isLoading && (
          <div className="download-section">
            {title && (
              <p className="video-title" aria-label="Video title">
                {title}
              </p>
            )}
            {(fileSize || duration) && (
              <p className="video-details" aria-label="Video details">
                {fileSize && `Size: ${formatFileSize(fileSize)}`}
                {fileSize && duration && " • "}
                {duration && `Duration: ${formatDuration(duration)}`}
              </p>
            )}
            <a
              href={urlResult}
              target="_blank"
              rel="noreferrer"
              className="download-button"
              aria-label={`Download MP3 for ${title || "video"}`}
            >
              Download MP3
            </a>
          </div>
        )}
      </div>
      <footer className="footer">
        <p className="footer-text">
          © 2025 Crafted with ❤️ by{" "}
          <a
            className="footer-link"
            href="https://github.com/mzohaib-dev"
            aria-label="GitHub profile of Muhammad Zohaib"
          >
            Muhammad Zohaib
          </a>
        </p>
      </footer>
    </div>
  );
}

export default App;
